<div class="assignedComponent" (window:resize)="onResize($event)">

    <div class="btns-container" style="position:absolute;top:7px;right:1px;">
        <!--<a id="showFilter" (click)="showFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
            <i class="fas fa-filter text-white-50"> <span class="button-text"> Search</span></i>
        </a>
        <a id="hideFilter" (click)="hideFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
            <i class="fas fa-filter text-white-50"> <span class="button-text"> Hide Search</span></i>
        </a>-->
        <!--<a (click)="goToConversionRate()" *ngIf="_Globals.assignedAssessmentType == 1.2" id="conversionRate" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': _Globals.assignedCanConversionRate, 'btn-gray': !_Globals.assignedCanConversionRate}">
            <i class="fas fa-table text-white-50"> <span class="button-text"> Conversion Rate</span></i>
        </a>-->

        <a id="addTagsAssessments" (click)="openAddTagsAssessmentsModal()" [ngClass]="{'btn-primary': _Globals.assignedCanAddTags, 'btn-gray': !_Globals.assignedCanAddTags || selectedRowsCount === 0}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
            <i class="fas fa-tag text-white-50"> <span class="button-text"> Tags</span></i>
        </a>

        <a (click)="sendReminder()" id="sendReminder" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': _Globals.assignedCanSendReminder, 'btn-gray': !_Globals.assignedCanSendReminder}">
            <i class="fas fa-send text-white-50"> <span class="button-text"> Resend Invitation</span></i>
        </a>
        <a (click)="openExtendModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': _Globals.assignedCanUpdate, 'btn-gray': !_Globals.assignedCanUpdate}">
            <i class="fas fa-calendar-day text-white-50"> <span class="button-text"> Update</span></i>
        </a>
        <a (click)="copy()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5" [ngClass]="{'btn-other': _Globals.assignedCanCopy, 'btn-gray': !_Globals.assignedCanCopy}">
            <i class="fas fa-copy text-white-50"> <span class="button-text"> Copy link</span></i>
        </a>
        <!--assignRaters()-->
        <a *ngIf="_Globals.assignedAssessmentType == 1.2" (click)="showRatersModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': _Globals.assignedCanAddRaters, 'btn-gray': !_Globals.assignedCanAddRaters}">
            <i class="fas fa-users text-white-50"> <span class="button-text"> Raters</span></i>
        </a>
        <a (click)="openConfirmModal()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm" [ngClass]="{'btn-red': _Globals.assignedCanDelete, 'btn-gray': !_Globals.assignedCanDelete}">
            <i class="fas fa-user-times text-white-50"> <span class="button-text"> Unassign</span></i>
        </a>
    </div>

    <ng-container *ngIf="loading; else content">
        <div class="loading text-center">
            <br />
            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
            <br />
            <p>Loading, please wait...</p>
        </div>
    </ng-container>

    <ng-template #content>
        <div class="container-fluid">
            <!--<div class="row">
                <div class="col-md-12">
                    <label>Type: </label>
                </div>
            </div>-->
            <!--<div class="row">
                <div class="col-md-12">
                    <select (change)="filterAssigned()">
                        <option selected="selected" class="option" value="false">Regular</option>
                        <option class="option" value="true">360</option>
                    </select>
                </div>
            </div>-->



            <div class="row">

                <div>
                    <ul class="nav nav-tabs assignedTabs">
                        <li (click)="tabSelected(1.1)" class="active"><a data-toggle="tab" href="#assignedTab1">ELI - Self Assessment</a></li>
                        <li (click)="tabSelected(1.2)"><a data-toggle="tab" href="#assignedTab2">ELI 360</a></li>
                    </ul>
                </div>

                <div class="tab-content assignedTabs">
                    <div id="assignedTab1" class="tab-pane fade in active">
                        <div class="row container-fluid">
                            <div class="col-xs-9  col-sm-5">
                                <tag-input [(ngModel)]='tags'
                                           [addOnBlur]="true"
                                           (onRemove)="onItemRemoved(1, $event)"
                                           (onAdd)="onItemAdded(1, $event)"
                                           [secondaryPlaceholder]="placeholder"
                                           [placeholder]="placeholder"
                                           [inputId]="'tagsInput'"
                                           (onFocus)="onFocusInput()"
                                           [theme]="'foundation-theme'"></tag-input>
                                <i class="fas fa-search searchIcon" (click)="focusTagsInput('tagsInput')"></i>
                                <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(1)">My tags</a>
                            </div>
                            <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help" class="fas fa-question-circle pointer"></i>
                            <popover-content #help
                                             title="Tags"
                                             placement="right"
                                             [animation]="true"
                                             [closeOnClickOutside]="true">
                                <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                            </popover-content>
                        </div>

                        <br />

                        <div id="assignedAssessments" style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #agGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [enableFilter]="true"
                                             [gridOptions]="gridOptions"
                                             [rowData]="_Globals.assignedRegularData"
                                             [columnDefs]="dataHeaders"
                                             [enableSorting]="true"
                                             [enableColResize]="true"
                                             (rowClicked)="onRowClicked($event)"
                                             [floatingFilter]="true"
                                             (gridReady)="onGridReady(1, $event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                             [rowSelection]="rowSelection"
                                             (selectionChanged)="onSelectionChangedChoiceSet($event)"
                                             [rowMultiSelectWithClick]="true">
                            </ag-grid-angular>
                        </div>
                    </div>

                    <div id="assignedTab2" class="tab-pane fade">
                        <div class="row container-fluid">
                            <!--<div class="col-xs-4 col-sm-offset-5 col-sm-2" >
                                <h5>Search by tag:</h5>
                            </div>-->
                            <div class=" col-xs-9 col-sm-5">
                                <tag-input [(ngModel)]='tags360'
                                           [addOnBlur]="true"
                                           (onRemove)="onItemRemoved(2, $event)"
                                           (onAdd)="onItemAdded(2, $event)"
                                           [secondaryPlaceholder]="placeholder"
                                           [placeholder]="placeholder"
                                           [inputId]="'tagsInput360'"
                                           (onFocus)="onFocusInput()"
                                           [theme]="'foundation-theme'"></tag-input>
                                <i class="fas fa-search searchIcon" (click)="focusTagsInput('tagsInput360')"></i>
                                <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(2)">My tags</a>
                            </div>
                            <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help360" class="fas fa-question-circle pointer"></i>
                            <popover-content #help360
                                             title="Tags"
                                             placement="right"
                                             [animation]="true"
                                             [closeOnClickOutside]="true">
                                <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                            </popover-content>
                        </div>

                        <br />

                        <div id="assignedAssessments" style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #agGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [enableFilter]="true"
                                             [gridOptions]="gridOptions"
                                             [rowData]="_Globals.assigned360Data"
                                             [columnDefs]="dataHeaders360"
                                             [enableSorting]="true"
                                             [enableColResize]="true"
                                             (rowClicked)="onRowClicked($event)"
                                             [floatingFilter]="true"
                                             (gridReady)="onGridReady(2, $event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                             [rowSelection]="rowSelection"
                                             (selectionChanged)="onSelectionChangedChoiceSet($event)"
                                             [rowMultiSelectWithClick]="true">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>

            <p id="linkToCopy" style="display:none;"></p>
        </div>
    </ng-template>
</div>

<!--<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<app-assign-assesments-modal #assignAssessment></app-assign-assesments-modal>-->
<!--/*unassign CONFIRMATION MODAL*/-->
<div id="confirmModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Assessment</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to unassign the selected assessments?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Loading...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirm()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*import modal*/-->
<div id="importRaterModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Import Raters</h2>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div *ngIf="importRaterPageIdx == 0" class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="iFile" />
                        </div>
                    </div>
                </div>

                <div *ngIf="importRaterPageIdx == 1" class="row">
                    <div class="page2">
                        <h5>Language and Dates</h5>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Language: </label>
                            </div>
                            <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                                <select #importLanguage id="importLanguages">
                                    <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row radios">
                            <div class="col-sm-12 col-md-3 datepicker">
                                <label style="text-align: right;">Schedule for:</label>
                            </div>
                            <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="importDatapiker">

                                <label class="container">
                                    Now
                                    <input type="radio" checked="checked" name="schedule" value="0">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <label class="container responsiveRadioLabel">
                                    <span style="margin-left:5px;"></span>
                                    <input type="radio" name="schedule" value="1">
                                    <span style="left: 18px;" class="checkmark"></span>
                                </label>
                                <!-- NEW DATE PICKER -->
                                <input id="inputDatePicker" type="date" [(ngModel)]="importDate" (change)="onDateSelect(importDate)">
                            <!-- NEW DATE PICKER -->
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event)" [(ngModel)]="importDate" [settings]="settings"></angular2-date-picker> -->
                            </div>
                            <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="importDivHour">
                                <select (change)="importHourChanged()" class="blueSelect" id="importHour">
                                    <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Expires in:</label>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <input id="importExpiresIn" type="number" name="text" value="30" max="30" min="0" />
                                <span>day(s)</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="row">
                        <div class="col-md-12">
                            <button *ngIf="importRaterPageIdx == 0" (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                            <button *ngIf="importRaterPageIdx > 0" (click)="importRaterPrev()" type="button" class="btn btn-primary">Previous</button>
                            <button *ngIf="importRaterPageIdx < 1" style="margin-right: 25px;" (click)="importRaterNext()" type="button" class="btn btn-primary">Next</button>
                            <button *ngIf="importRaterPageIdx == 1" style="margin-right: 25px;" (click)="okImportRaters()" type="button" class="btn btn-primary">Finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*extend modal*/-->
<div id="extendModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" style="max-width: 470px;margin: 30px auto;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Update Assignment</h2>
                <button type="button" class="close" (click)="closeExtendModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-3 text-right" style="padding-right:0px;">
                        <p>Send on:</p>
                    </div>
                    <div class="col-12 col-md-9 schedule">
                        <div class="row">
                            <div class="col-xs-6 col-md-6 noPadding">
                                <div>
                                    <!-- NEW DATE PICKER -->
                                <input id="sentDateInput" [ngStyle]="{'pointer-events': pointerEvents ? 'auto' : 'none' }" type="date" [(ngModel)]="sentDate" (change)="onDateSelect(sentDate, 1)">
                                <!-- NEW DATE PICKER -->
                                    <!-- <angular2-date-picker [ngStyle]="{'pointer-events': pointerEvents ? 'auto' : 'none' }" (onDateSelect)="onDateSelect($event, 1)" [(ngModel)]="sentDate" [settings]="settings"></angular2-date-picker> -->
                                </div>
                            </div>
                            <div class="col-xs-6 col-md-6 noPadding removePaddingOnResponsive" style="padding-left: 10px !important;">
                                <div>
                                    <select [ngStyle]="{'pointer-events': pointerEvents ? 'auto' : 'none' }" class="blueSelect" id="assessmemntsAssignedUpdateHour">
                                        <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-3 text-right" style="padding-right:0px;">
                        <p>Expires on:</p>
                    </div>
                    <div class="col-12 col-md-9 expiration">
                        <div class="row">
                            <div class="col-6 col-md-6 noPadding">
                                <!-- NEW DATE PICKER -->
                                <input id="expiresDatePicker" type="date" [(ngModel)]="expiresOn" (change)="onDateSelect(expiresOn, 2)" [min]="getTodayDate2()">
                            <!-- NEW DATE PICKER -->
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event, 2)" [(ngModel)]="expiresOn" [settings]="settings"></angular2-date-picker> -->
                            </div>
                        </div>
                        <!--<input id="extendedExpiresIn" type="number" name="text" min="0" />-->
                    </div>
                    <!--<div class="col-xs-3 col-md-2">
                        <span>day(s)</span>
                    </div>-->
                </div>
            </div>

            <div class="modal-footer">
                <div class="row" style="padding-right: 25px;">
                    <div class="col-md-12">
                        <button (click)="closeExtendModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="extendExpirationDate()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*ADD  TAGS modal*/-->
<div id="assignedAddTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add tags</h2>
                <button (click)="closeAddTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row container-fluid">
                    <div class="col-xs-2">
                        <span>Tags</span>
                        <i style="margin-left:0;position:relative;top:0;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>
                    <div class="col-xs-8" style="margin-top: -10px;">
                        <tag-input [(ngModel)]='addTags'
                                   [addOnBlur]="true"
                                   (onRemove)="onItemRemoved(3, $event, true)"
                                   (onAdd)="onItemAdded(3, $event)"
                                   [secondaryPlaceholder]="placeholder"
                                   [placeholder]="placeholder"
                                   [inputId]="'completedTagsInput'"
                                   (onFocus)="onFocusInput()"
                                   [theme]="'foundation-theme'"></tag-input>
                        <i class="fas fa-search searchIcon" (click)="focusTagsInput('completedTagsInput')"></i>
                    </div>
                    <div class="col-xs-2">
                        <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(3)">My tags</a>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeAddTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addAssessmentsTags()" [disabled]="assessmentAddTags.length === 0" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*tags modal*/-->
<div id="tagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeTag(i, tag.Text)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0">
                    <input type="text" placeholder="Select tags from the table" id="placeholderInput" readonly />
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*assigned tags modal*/-->
<div id="assignedTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeTag(i, tag.Text)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0">
                    <input type="text" placeholder="Select tags from the table" id="placeholderInput2" readonly />
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" [disabled]="selectedCoachTags.length === 0" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--raters types-->
<app-rater-types-for-modal #raterTypesForModal></app-rater-types-for-modal>

<!--raters Modal-->
<div id="assignedId">
    <app-raters-modal #ratersModal></app-raters-modal>
</div>
